// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/assets/syncspace.png",
    title: "SyncSpace",
    description:
      "SyncSpace is a real-time collaboration platform that brings individuals and teams together. Experience seamless group and private chat, all in one place.",
    tech_stack: "MERN Stack, Socket.io",
    github_url: "https://github.com/akkarn1689/SyncSpace",
    demo: false,
  },
  {
    img: "/assets/project_0.png",
    title: "Devhub",
    description:
      "Devhub is the ultimate social platform designed exclusively for developers. Join Devhub today to showcase your skills and connect.",
    tech_stack: "React js, Redux, Node js, Express js, MongoDb",
    github_url: "https://github.com/akkarn1689/devhub",
    demo_url: "https://devhub-p5f4.onrender.com/",
    demo: true,
  },
  {
    img: "/assets/project_2.png",
    title: "Video Streaming",
    description:
      "A video streaming app powered by YouTube APIs, featuring live video playback and an integrated live chat feed.",
    tech_stack: "React js, Redux, Tailwind CSS",
    github_url: "https://github.com/akkarn1689/video_streaming_app",
    demo_url: "https://video-streaming-app-5msi.onrender.com/",
    demo: true,
  },
];

export const ExperienceList = [
  {
    title: "FlexiEle Consulting Service Pvt. Ltd.",
    role: "Associate Technology (Dec 2024 - Present)",
    description: [
      "Developed and optimized backend features for a multi-tenant HRMS application, based on a 3-tier application architecture.",
      "Implemented a scalable bulk document upload and download feature, automating document generation and streamlining HR workflows.",
      "Implemented a thumbnail generation feature using Amazon S3 Object Lambda, enhancing application performance by serving optimized images by default and retrieving original files only when explicitly required.",
      "Integrated WhatsApp via Twilio into the core notification feature of the application, enhancing multi-channel communication alongside existing email and SMS functionality.",
      "Implemented an end-to-end feature for document analysis and data extraction using the Gemini-1.5-Flash API, enabling seamless processing of uploaded documents and facilitating form autofill for enhanced user efficiency.",
      "Implemented backend for Proxy User and Access Control features, enabling robust user management capabilities.",
      "Implemented cron job scheduling for tasks automating for feature like leave accrual & employee absconding, streamlining operations, and reducing manual work.",
    ],
    isc: false,
  },
  {
    title: "Pried.in",
    role: "Frontend Developer (May 2024 - November 2024)",
    description: [
      "Built core modules for a React-based Institute Management System, including student and faculty management,file sharing, attendance tracking, vehicle tracking and notifications.",
      "Contributed to the Learning Module, which includes features like the video content, class notes and assessments.",
      "Developed parts of the React Native mobile application, ensuring consistency with the web platform.",
      "Integrated APIs and managed state with Redux to ensure smooth data flow and responsive UI.",
      "Assisted in the development of a Hospital Management System, focusing on inventory management for medicine stock tracking and room allocation features."
    ],
    // certificate: "https://drive.google.com/file/d/1eQbEyzSLC6h14S5gycv2Lj-apLHL4tGt/view?usp=sharing",
    isc: false,
  },
  {
    title: "FOG",
    description: [
      "Developed and optimized key features for a gaming product, leveraging modern frameworks to improve performance and reduce bug reports by 30%",
      "Built scalable and reusable UI components, streamlining the development process for future features and reducing maintenance time.",
      "Enhanced API integrations and optimized database operations, improving data flow and backend efficiency."
    ],
    role: "Software Developer Intern (Mar 2024 - April 2024)",
    // certificate: "https://drive.google.com/file/d/1PiN9LesVSba5UXuMJayS2Z7k6la5w5Tc/view?usp=sharing",
    isc: false,
  },
];

// --------------------------------------- Skills

export const stackList = [
  // {
  //   img: "/assets/skill/rust.svg",
  //   name: "Rust",
  // },
  {
    img: "/assets/skill/c.png",
    name: "C/C++",
  },
  {
    img: "/assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "/assets/skill/typescript.png",
    name: "TypeScript",
  },
  {
    img: "/assets/skill/nodejs.png",
    name: "Node Js",
  },
  {
    img: "/assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "/assets/skill/redux.png",
    name: "Redux",
  },
  {
    img: "/assets/skill/nextjs.svg",
    name: "Next Js",
  },
  {
    img: "/assets/skill/smartphone.png",
    name: "React Native",
  },
  {
    img: "/assets/skill/mysql.png",
    name: "MySQL",
  },
  {
    img: "/assets/skill/mongo.png",
    name: "MongoDB",
  },
  {
    img: "/assets/skill/postgre.png",
    name: "Postgre SQL",
  },
  {
    img: "/assets/skill/redis.png",
    name: "Redis",
  },
  {
    img: "/assets/skill/python.png",
    name: "Python",
  },
  {
    img: "/assets/skill/java.png",
    name: "Java",
  },
];

export const toolist = [
  {
    img: "/assets/skill/ubuntu.png",
    name: "Ubuntu",
  },
  {
    img: "/assets/skill/vs.png",
    name: "Vs code",
  },
  {
    img:"/assets/skill/intellij.png",
    name:"IntelliJ"
  },
  {
    img: "/assets/skill/docker.png",
    name: "Docker",
  },
  {
    img: "/assets/skill/postman.png",
    name: "Postman",
  },
  {
    img: "/assets/skill/aws.png",
    name: "Aws",
  },
];
